type Listener = () => void;

const listeners = new Set<Listener>();

/**
 * Tells the members table that members were added, from the Manage members button in
 * the section's header, which the table can't reach through props.
 */
export function onMarketingListMembersChanged(listener: Listener) {
  listeners.add(listener);

  return () => {
    listeners.delete(listener);
  };
}

export function notifyMarketingListMembersChanged() {
  listeners.forEach((listener) => listener());
}
